module.exports = __webpack_public_path__ + "static/media/bandwidth_logo.fb492f1d.png";